import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { ClientService } from '../../../../services/clients';
import { ComplexService } from '../../../../services/complexrequest';

@Component({
  selector: 'app-create-complex-request',
  templateUrl: './create-complex-request.component.html',
  styleUrl: './create-complex-request.component.scss'
})
export class CreateComplexRequestComponent {

  data!: FormGroup;
  dataForm: FormData = new FormData();
  contentReady: boolean = false;
  isMobile: boolean = false;
  isAr: boolean = false;
  editId!: any;
  isUpdatePage: boolean = false;
  systemAccess: boolean = false;
  type: string = 'text';

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;

  constructor(
    private fb: FormBuilder,
    private _complex: ComplexService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") === "ar";
    this.contentReady = true;
        this.initForm();
    this.route.queryParams.subscribe(params => {
      if (params["id"]) {
        this.isUpdatePage = true;
        this.editId = params["id"];
        // ✨ املا النموذج من params
        this.data.patchValue({
          complex_name: params["complex_name"] || '',
          complex_location: params["complex_location"] || '',
          request_details: params["request_details"] || '',
          notes: params["notes"] || '',
        });
      }
    });


  }

  initForm() {
    this.data = this.fb.group({
      complex_name: ['', Validators.required],
      complex_location: [''],
      request_details: ['', Validators.required],
      notes: [''],
    });
  }


  appendPostDtata() {
    this.dataForm = new FormData();
this.dataForm.append('complex_name', this.data.get('complex_name')?.value);
  this.dataForm.append('complex_location', this.data.get('complex_location')?.value);
  this.dataForm.append('request_details', this.data.get('request_details')?.value);
  this.dataForm.append('notes', this.data.get('notes')?.value);
  this.dataForm.append('add_by', localStorage.getItem("username") || '');
  }



  onSubmit() {
    this.appendPostDtata();

    if (this.isUpdatePage) {
      this.onEdit();
    } else {
      this.onAdd();
    }
  }

  onAdd() {
    this.contentReady = true;
    this._complex.create(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إنشاء " : 'created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
        const redirectUrl = '/complex';
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل  " : 'not created',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });

        this.contentReady = false;
      }
    });
  }

 onEdit() {
   this.contentReady = true;
   this._complex.updateCustom(this.editId,this.dataForm).subscribe({
     next: (res) => {
       Swal.fire({
         icon: 'success',
         title: this.isAr ? "تم تعديل " : ' updated',
         showConfirmButton: false,
         timer: 1500,
       });

       this.contentReady = false;
   const redirectUrl ='/complex';
       this.router.navigateByUrl(redirectUrl);
     },
     error: (err) => {
       Swal.fire({
         icon: 'error',
         title: this.isAr ? "فشل  " : ' not updated',
         confirmButtonText: this.isAr ? 'تمام' : 'OK',
       });

       this.contentReady = false;
     }
   });
 }





}
